import { IUser } from ".";

export interface IUserItem {
    user: IUser,
    isAssigned: boolean,
    isPrimary: boolean,
    selected: boolean
}